import React from 'react';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper";
import "./slider.css";

export default class BrandOne extends React.Component {
    render() {
        const publicUrl = process.env.PUBLIC_URL + '/';
        const brandImages = [
            "abb.png",
            "allen-bradley.png",
            "beckhoff.png",
            "caterpillar.png",
            "kongsberg.png",
            "peperel.png",
            "phoenix-contact.png",
            "schneider.png",
            "Siemens_AG_logo.svg"
        ];

        return (
            <section className="brand-one-sec py-10 bg-gray-50">
                <div className="container mx-auto px-4">
                    <Swiper
                        modules={[Autoplay]}
                        loop={true}
                        spaceBetween={30}
                        slidesPerView={5}
                        speed={1000}
                        autoplay={{ delay: 2000, disableOnInteraction: false }}
                        breakpoints={{
                            0: { slidesPerView: 2 },
                            480: { slidesPerView: 3 },
                            768: { slidesPerView: 4 },
                            1024: { slidesPerView: 5 },
                        }}
                        className="brand-slider"
                    >
                        {brandImages.map((img, index) => (
                            <SwiperSlide key={index}>
                                <div className="brand-card group flex items-center justify-center bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 p-4">
                                    <Link to={process.env.PUBLIC_URL + `/`}>
                                        <img
                                            src={`${publicUrl}assets/images/brand/${img}`}
                                            alt={`Brand ${index + 1}`}
                                            className="w-32 h-auto opacity-80 group-hover:opacity-100 transform group-hover:scale-105 transition-all duration-300"
                                        />
                                    </Link>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </section>
        );
    }
}
